import { render, staticRenderFns } from "./notice-info.vue?vue&type=template&id=55b3b18e&scoped=true&"
import script from "./notice-info.vue?vue&type=script&lang=js&"
export * from "./notice-info.vue?vue&type=script&lang=js&"
import style0 from "./notice-info.vue?vue&type=style&index=0&id=55b3b18e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b3b18e",
  null
  
)

export default component.exports